import { axiosInstance } from "../../../axios/axiosInstance";

const API_SUPER_ADMIN_SERVICES_URL = "admin/organization";
const API_SUPER_ADMIN_SERVICES_MODULE_LIST_URL = API_SUPER_ADMIN_SERVICES_URL + "/list";

export const getSuperAdminServices = (dataToBeSent) => {
  return axiosInstance.get(API_SUPER_ADMIN_SERVICES_MODULE_LIST_URL);
};


